<template>
  <!-- Display desktop image -->
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
    <SmartLinkStandaloneElement :codename="typ.elements.caption.codename">
      <div class="full-width-image desktop">
        <div class="container">
          <NuxtImg class="img-fluid" :alt="data.altText" :src="data.img?.url" />
          <RichText :value="data.caption" />
        </div>
      </div>

      <!-- display mobile image -->
      <div class="full-width-image mobile">
        <div class="container">
          <NuxtImg class="img-fluid" :alt="data.altText" :src="data.mobileImage?.url" />
          <RichText :value="data.caption" />
        </div>
      </div>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { FullWidthImageModel } from '~/models';
import { contentTypes } from '~/models';
const typ = contentTypes.full_width_image;


const props = defineProps<{ model: FullWidthImageModel }>();
const data = {
  img: firstOrDefault(props.model.elements.image.value),
  mobileImage: firstOrDefault(props.model.elements.mobileImage.value),
  caption: props.model.elements.caption.value,
  altText: props.model.elements.image.value[0].description ?? ""
}
</script>
